import { render, staticRenderFns } from "./ArticulosPopUp.vue?vue&type=template&id=687d7a13&scoped=true"
import script from "./ArticulosPopUp.vue?vue&type=script&lang=js"
export * from "./ArticulosPopUp.vue?vue&type=script&lang=js"
import style0 from "./ArticulosPopUp.vue?vue&type=style&index=0&id=687d7a13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687d7a13",
  null
  
)

export default component.exports